import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import { 
    Button, 
    FormControl,
    InputAdornment,
    InputLabel,
    MenuItem,
    Select,
} from '@mui/material/';
import DeleteIcon from '@mui/icons-material/Delete';
import { Input } from '@mui/base';
import { TextField } from '@mui/material/';
import SearchIcon from "@mui/icons-material/Search";
import Autocomplete from '@mui/material/Autocomplete';
import { useCallback, useMemo, useState, useEffect } from 'react';
import "./RightGrid.css"
import {getAllVM, getAllItems, publish_slot, getAllSlotsItems} from '../../api/routes'
import RightGridTable from './RightGridTable';
import  mqtt from "mqtt";

const options = {
    username: 'operator_ws',
    password: 'Q4ddoje88D_u1cUsTUHwI30dtbwdj6LP',
    rejectUnauthorized: true,
    reconnectPeriod: 2000,
};

// Connect to the broker using wss://
const client_right_grid = mqtt.connect('wss://ivm9.in:9001', options);
client_right_grid.on('connect', () => {
    console.log('Connected to MQTT broker from right grid');
});

export function RightGrid({user_id}) {
    const cashAcceptTopicFormat = 'cash/accept/vendingmachine';
    const [searchTerm, setSearchTerm] = useState("");
    const [loading, setLoading] = useState(true);
    const [itemData, setItemData] = useState(() => []);
    const [searchValue, setSearchValue] = useState(itemData[0]);
    const [rows, setRows] = useState([]);
    const [itemSlots, setItemSlots] = useState([]);
    const [selectedVM, setSelectedVM] = useState("");
    // const [slots, setSlots] = useState(0);
    const [opVm, setOpVM] = useState([]);
    const [paymentMode, setPaymentMode] = useState('');
    const [cashReceived, setCashReceived] = useState('');
    const [cashlessConfirmed, setCashlessConfirmed] = useState(false);
    const [cashAccepted, setCashAccepted] = useState(false);
    const [isDispensing, setIsDispensing] = useState(false);

    function ccyFormat(num) {
        return `${num.toFixed(2)}`;
    }

    function priceRow(qty, unit) {
        return qty * unit;
    }

    function createRow(desc, stock, qty, unit, itemId, slotId, vmId, slotAllocations = []) {
        const price = priceRow(qty, unit);
        const slotIdsLabel = slotAllocations.length > 1
            ? `Slots ${slotAllocations.map((slot) => slot.slotId).join(', ')}`
            : `Slot ${slotId}`;
        return { desc, stock, qty, unit, price, itemId, slotId, vmId, slotAllocations, slotIdsLabel };
    }

    function getStockedSlotsForItem(itemId, vmId = '') {
        return itemSlots
            .filter((item_slot) => item_slot.item_id_id === itemId
                && item_slot.quantity > 0
                && (!vmId || item_slot.vending_machine_id_id === vmId))
            .sort((left, right) => parseInt(left.slot_id, 10) - parseInt(right.slot_id, 10));
    }

    function getSlotAllocationsForItem(itemId, vmId = '') {
        return getStockedSlotsForItem(itemId, vmId).map((slot) => ({
            slotId: parseInt(slot.slot_id, 10),
            vmId: slot.vending_machine_id_id,
            quantity: parseInt(slot.quantity || 0, 10),
        }));
    }

    function subtotal(items) {
        return items.map(({ price }) => price).reduce((sum, i) => sum + i, 0);
    }

    function adItemToTable(event, newValue) {
        console.log("ONCHANGE>>>>>>>>>>>>>>>>>>", newValue)
        if (!newValue) return
        // console.log({newValue, event})
        setSearchValue(newValue);
        const obj = itemData.find(item => item.item_name === newValue);
        const currentVmId = rows[0]?.vmId;
        const initialSlots = getStockedSlotsForItem(obj.guid, currentVmId);
        const itemSlot = initialSlots[0];
        // console.log({ obj });
        if (!itemSlot) return;
        const vmId = itemSlot.vending_machine_id_id;
        const slotAllocations = getSlotAllocationsForItem(obj.guid, vmId);
        const stock = slotAllocations.reduce((sum, slot) => sum + slot.quantity, 0);
        setRows([
            ...rows,
            createRow(newValue, stock, 1, obj.item_price, obj.guid, itemSlot.slot_id, vmId, slotAllocations),
        ]);


        // const rows = [
        //     createRow('Paperclips (Box)', 100, 1.15),
        //     createRow('Paper (Case)', 10, 45.99),
        //     createRow('Waste Basket', 2, 17.99),
        //     ];
    }

    const deleteRow = (event, index)=> {
        console.log("rrrrrrroooooooowwwwwwwwwwwws",{rows}, index);
        let curr_rows = [...rows];
        console.log("111111111", {curr_rows})
        curr_rows = curr_rows.filter((item, i) => i !== index);
        console.log("222222222", {curr_rows})

        setRows(curr_rows);
        // console.log("rrrrrrroooooooowwwwwwwwwwwws",{rows});
    }

    const setQuantity = (e, index) => {
        // console.log("E", e.target.value );
        // console.log({rows});
        const new_rows = [...rows];
        if(e.target.value){
            if (parseInt(e.target.value) <= new_rows[index]["stock"]) {
                new_rows[index]["qty"] = parseInt(e.target.value);
                new_rows[index]["price"] = parseFloat(e.target.value) * new_rows[index]["unit"];
            }
        }
        else
            new_rows[index]["qty"] = 0;
        setRows(new_rows);
    }

    function getItemSlotsForOperator(item_slots, vms, items) {
        // console.log("++++", { item_slots, vms, items });
        const resItemSlots = [];
        const resItems = [];
        item_slots.forEach(item => {
            vms.forEach(vm => {
                if (item.vending_machine_id_id === vm.guid) {
                    client_right_grid.subscribe(`vm/${vm.guid}/call/status`);
                    client_right_grid.subscribe(`heartbeat/vendingmachine/alive/${vm.guid}`)
                    client_right_grid.subscribe(`heartbeat/vendingmachine/dead/${vm.guid}`)
                    if (vm.status === 10 && vm.call_status === 5)
                        resItemSlots.push(item);
                }  
            });
        })

        const seenItemIds = new Set();
        items.forEach(item => {
            if (seenItemIds.has(item.guid)) {
                return;
            }
            const hasStockedSlot = resItemSlots.some(item_slot => item_slot.item_id_id === item.guid && item_slot.quantity > 0);
            if (hasStockedSlot) {
                seenItemIds.add(item.guid);
                resItems.push(item);
            }
        })
        // console.log(">>>>>>>", {resItemSlots, resItems});
        return [resItemSlots, resItems];
    }

    const fetchData = async () => {
        setLoading(true);
        try {
            // const users = await getAllUsers();
            // setAdmins(getAdminsFromUsers(users));
            const [items, vms, item_slot] = await Promise.all([getAllItems(), getAllVM(), getAllSlotsItems()]);
            // console.log({vms, item_slot});
            const opVMs = vms
                .filter(vm => vm.operator_assigned_id === user_id)
                .map((vm) => ({ ...vm, has_coin_dispenser: Boolean(vm.metadata && vm.metadata.has_coin_dispenser) }));
            setOpVM(opVMs);
            const [opItemSlots, opItems] = getItemSlotsForOperator(item_slot, opVMs, items)
            setItemSlots(opItemSlots);
            setItemData(opItems);
            // setTableData(updateVMResponseData(vms));
            setLoading(false);
        } catch (error) {
            console.log("error", error);
            setLoading(false);
        }
    }
    
    useEffect(() => {
        console.log("useeffect");
        fetchData();
        // console.log("+++++++++++++++",{itemData});
    }, []);

    useEffect(() => {
        
        client_right_grid.on('message', (topic, message) => {
            console.log('--------- MQTT message received from right grid', topic, message, typeof message);
            
            message = JSON.parse(message.toString())
            // update call status .....
            if (message["type"] === "call_status" || message["type"] === "status") {
                setTimeout(() => {
                    fetchData();
                }, 300);
            }
        });
    },[])

    useEffect(() => {
        if (rows.length === 0) {
            setPaymentMode('');
            setCashReceived('');
            setCashlessConfirmed(false);
            setCashAccepted(false);
            return;
        }
        const activeVmIds = new Set(
            opVm
                .filter((vm) => vm.status === 10 && vm.call_status === 5)
                .map((vm) => vm.guid)
        );
        if (!activeVmIds.has(rows[0].vmId)) {
            setRows([]);
            setSearchValue("");
        }
    }, [opVm, rows]);

    const invoiceSubtotal = subtotal(rows);
    const invoiceTotal = invoiceSubtotal;
    const payableAmount = invoiceTotal;
    const currentVmId = rows[0]?.vmId || '';
    const currentVm = opVm.find((vm) => vm.guid === currentVmId);
    const currentVmHasCoinDispenser = Boolean(currentVm && currentVm.has_coin_dispenser);
    const activeVm = opVm.find((vm) => vm.guid === currentVmId && vm.status === 10 && vm.call_status === 5);
    const parsedCashReceived = parseInt(cashReceived || 0, 10);
    const changeAmount = paymentMode === 'cash' ? parsedCashReceived - payableAmount : 0;
    const canDispense = rows.length > 0 && activeVm && (
        !currentVmHasCoinDispenser
        || (paymentMode === 'cashless' && cashlessConfirmed)
        || (paymentMode === 'cash' && parsedCashReceived >= payableAmount && cashAccepted)
    );
    const handleChange = (event) => {
        setSearchTerm(event.target.value);
    };

    const acceptCash = () => {
        if (!activeVm || paymentMode !== 'cash') {
            return;
        }
        if (parsedCashReceived < payableAmount) {
            alert('Entered amount is less than the total price');
            return;
        }

        const topic = `${cashAcceptTopicFormat}/${currentVmId}`;
        const payload = JSON.stringify({
            type: 'cash_received',
            vm_id: currentVmId,
            cash_received: parsedCashReceived,
            total_amount: payableAmount,
            change_amount: changeAmount >= 0 ? changeAmount : 0,
        });

        if (!client_right_grid.connected) {
            alert('MQTT is not connected');
            return;
        }

        client_right_grid.publish(topic, payload, (error) => {
            if (error) {
                console.error('Cash accept publish failed', error);
                alert('Failed to send cash accept signal');
                return;
            }
            setCashAccepted(true);
        });
    };

    function buildSlotDetailsForDispense() {
        const slotQuantityMap = new Map();
        rows.forEach((row) => {
            let remainingQty = parseInt(row.qty || 0, 10);
            const allocations = row.slotAllocations && row.slotAllocations.length > 0
                ? row.slotAllocations
                : [{ slotId: row.slotId, quantity: row.stock }];

            allocations.forEach((allocation) => {
                if (remainingQty <= 0) {
                    return;
                }
                const availableQty = parseInt(allocation.quantity || 0, 10);
                const dispenseQty = Math.min(availableQty, remainingQty);
                if (dispenseQty > 0) {
                    const slotId = parseInt(allocation.slotId, 10);
                    slotQuantityMap.set(slotId, (slotQuantityMap.get(slotId) || 0) + dispenseQty);
                    remainingQty -= dispenseQty;
                }
            });

            if (remainingQty > 0) {
                throw new Error(`Insufficient combined stock for ${row.desc}`);
            }
        });

        return Array.from(slotQuantityMap.entries()).map(([slot, quantity]) => ({ slot, quantity }));
    }

    const dispenseItem = async (event) => {
        if (!canDispense || isDispensing) {
            return;
        }
        if (
            // eslint-disable-next-line no-restricted-globals
            !confirm(`Check the payment status. Click on OK to proceed`)
            ) return;
        // setSearchValue(undefined);
        let slot_details = [];
        try {
            slot_details = buildSlotDetailsForDispense();
        } catch (error) {
            alert(error.message || 'Insufficient stock');
            return;
        }
        const on_call_vm = rows[0]?.vmId || '';

        if (!on_call_vm || slot_details.length === 0 || !activeVm) {
            return;
        }

        setIsDispensing(true);
        try {
            await publish_slot({
                vm_data: on_call_vm,
                data: slot_details,
                payment_mode: currentVmHasCoinDispenser ? paymentMode : 'cashless',
                cash_received: currentVmHasCoinDispenser && paymentMode === 'cash' ? parsedCashReceived : 0,
            });
            setRows([]);
            setSearchValue("");
            setPaymentMode('');
            setCashReceived('');
            setCashlessConfirmed(false);
            setCashAccepted(false);
            fetchData();
        } catch (err) {
            const detail = err?.response?.data?.detail || 'Dispense failed';
            alert(detail);
        } finally {
            setIsDispensing(false);
        }
    }

    return (
        <Box sx={{ p: { xs: 1.25, md: 1.75 }, height: { xs: 'auto', xl: '100%' }, overflow: { xs: 'visible', xl: 'hidden' } }}>
            <Stack spacing={1.5} sx={{ height: { xs: 'auto', xl: '100%' } }}>
                <Box>
                    {/* <TextField 
                        id="standard-search"
                        label="Search . . ."
                        type="search"
                        variant="standard"  
                        sx={{ width: "100%", height:"10px" }} 
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                <SearchIcon />
                                </InputAdornment>
                            ),
                        }}
                        value={searchTerm}
                        onChange={handleChange}
                    /> */}
                    <Autocomplete
                        value={searchValue}
                        onChange={(event, newValue) => adItemToTable(event, newValue)}
                        openOnFocus
                        id="free-solo-2-demo"
                        // disableClearable
                        options={itemData.map((option) => option.item_name)}
                        noOptionsText={itemData.length > 0 ? "No matching items" : "Connect a machine to load items"}
                        renderInput={(params) => (
                        <TextField
                            {...params}
                            label="Search input"
                            InputProps={{
                            ...params.InputProps,
                            type: 'search',
                            endAdornment: (
                                <InputAdornment position="end">
                                <SearchIcon />
                                </InputAdornment>
                            ),
                            }}
                        />
                        )}
                    />
                </Box>

                <Box sx={{ flex: { xs: 'unset', xl: 1 }, minHeight: { xs: 'auto', xl: 0 } }}>
                   {!loading && <RightGridTable rows={rows} setQuantity={setQuantity} deleteRow={deleteRow} invoiceSubtotal={invoiceSubtotal} invoiceTotal={invoiceTotal} />}
                </Box>

                {rows.length > 0 && currentVmHasCoinDispenser && (
                <Paper variant="outlined" sx={{ p: 1.25, borderRadius: 3 }}>
                <Grid container spacing={1.25}>
                    <Grid item xs={12} md={3.5}>
                        <FormControl fullWidth>
                            <InputLabel id="payment-mode-label">Payment Mode</InputLabel>
                            <Select
                                labelId="payment-mode-label"
                                value={paymentMode}
                                label="Payment Mode"
                                onChange={(event) => {
                                    setPaymentMode(event.target.value);
                                    setCashlessConfirmed(false);
                                    setCashAccepted(false);
                                    setCashReceived('');
                                }}
                            >
                                <MenuItem value="cashless">Cashless</MenuItem>
                                <MenuItem value="cash">Cash</MenuItem>
                            </Select>
                        </FormControl>
                    </Grid>
                    {paymentMode === 'cashless' && (
                        <Grid item xs={12} md={3}>
                            <Button variant="contained" color={cashlessConfirmed ? 'success' : 'warning'} onClick={() => setCashlessConfirmed(true)} sx={{ minHeight: 44, borderRadius: 2.25 }}>
                                {cashlessConfirmed ? 'Received' : 'Mark Received'}
                            </Button>
                        </Grid>
                    )}
                    {paymentMode === 'cash' && (
                        <>
                            <Grid item xs={12} md={3}>
                                <TextField
                                    label="Amount Received"
                                    type="number"
                                    fullWidth
                                    value={cashReceived}
                                    onChange={(event) => {
                                        setCashReceived(event.target.value);
                                        setCashAccepted(false);
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12} md={2.5} sx={{ display: 'flex', alignItems: 'center', fontWeight: 700 }}>
                                Change: {changeAmount >= 0 ? changeAmount : 0}
                            </Grid>
                            <Grid item xs={12} md={3}>
                                <Button
                                    variant="contained"
                                    color={cashAccepted ? 'success' : 'warning'}
                                    onClick={acceptCash}
                                    disabled={!activeVm || parsedCashReceived < payableAmount}
                                    sx={{ minHeight: 44, borderRadius: 2.25 }}
                                >
                                    {cashAccepted ? 'Cash Accepted' : 'Accept Cash'}
                                </Button>
                            </Grid>
                        </>
                    )}
                </Grid>
                </Paper>
            )}

            <Box>
                <Button variant='contained' size="large" onClick={dispenseItem} disabled={!canDispense || isDispensing} sx={{ minWidth: 148, minHeight: 44, borderRadius: 2.5 }}>
                    {isDispensing ? 'Dispensing...' : 'Dispense'}
                </Button>
            </Box>
            </Stack>
        </Box>
    )
}
